import { FC } from "react";
import { useTaxonomyContext } from "../../../../contexts/Taxonomy/TaxonomyContext";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { ICPMarketDisplay } from "./ICPMarketDisplay";

/**
 * Component that displays SAM (Serviceable Addressable Market) data
 * Shows industry and geography information as chips
 */
export const ICPSAMDisplay: FC = () => {
  const industryDistribution = useWorkspaceStore(
    (state) => state.icpIndustryDistribution
  );
  const geographyDistribution = useWorkspaceStore(
    (state) => state.icpGeographyDistribution
  );

  const { hgIndustries, countries } = useTaxonomyContext();

  const significantIndustries =
    industryDistribution?.filter((item) => item.isSignificant) || [];
  const significantCountries =
    geographyDistribution?.filter((item) => item.isSignificant) || [];

  const industryNames = significantIndustries
    .map(
      (item) =>
        hgIndustries.find((industry) => industry.id === item.industryId)?.name
    )
    .filter(Boolean) as string[];

  const countryNames = significantCountries
    .map(
      (item) =>
        countries.find((country) => country.alpha2 === item.countryCode)?.name
    )
    .filter(Boolean) as string[];

  const sections = [
    {
      title: "INDUSTRY",
      items: industryNames.map((name) => ({
        label: name,
      })),
      emptyMessage: "No significant industries found",
    },
    {
      title: "GEOGRAPHY",
      items: countryNames.map((name) => ({
        label: name,
      })),
      emptyMessage: "No significant geography found",
    },
  ];

  return (
    <ICPMarketDisplay
      title="Serviceable Addressable Market (SAM)"
      sections={sections}
      emptyMessage="No significant SAM data available"
      hasData={
        significantIndustries.length > 0 || significantCountries.length > 0
      }
    />
  );
};
